import { GAEventName } from 'analytics/ga-event-name.enum';
import { StoreEnum } from 'schema/storeCode';
import { createAnalyticsEvent } from '../create-analytics-event';

type ProductDataTypeForEvent = {
  item_id: number;
  item_name: string;
  item_brand: string;
  item_variant?: string;
  variant_id?: number | string;
  price: number;
  currency: string;
  quantity: number;
  index?: number;
  flavor?: string;
}[];

type ProductDataTypeForOfferEvent = {
  name: string;
  productId: number;
  variantId?: number;
  brand: string;
  variant?: string;
  price: number;
  quantity: number;
  category: string;
}[];

export interface ViewProductVariantsForCheckoutPayload {
  item_list_name?: string;
  item_list_id?: string;
  affiliation?: string | string[] | boolean;
  items?: ProductDataTypeForEvent;
  discountCode?: string;
  eventId?: string;
}
export const viewProductVariantsForCheckoutEvent =
  createAnalyticsEvent<ViewProductVariantsForCheckoutPayload>(
    ({ item_list_name, item_list_id, affiliation, items, eventId = 'second_step' }) => ({
      event: GAEventName.PRODUCT_VARIANTS_FOR_CHECKOUT,
      event_id: eventId,
      ecommerce: {
        item_list_name,
        item_list_id,
        affiliation,
        items
      }
    })
  );

export const addToCartEvent = createAnalyticsEvent<{
  eventId: string;
  item_list_name?: string;
  item_list_id?: string;
  affiliation?: string | string[] | boolean;
  items?: ProductDataTypeForEvent;
  store?: StoreEnum;
  currency?: string;
  value?: string;
  deviceType?: string;
  isStandaloneProduct?: boolean;
}>(
  ({
    item_list_name,
    item_list_id,
    affiliation,
    items,
    eventId,
    store,
    currency,
    value,
    deviceType,
    isStandaloneProduct
  }) => ({
    event: GAEventName.ADD_TO_CART,
    event_id: eventId,
    store,
    isStandaloneProduct,
    ecommerce: {
      item_list_name, // when displayed in a list
      item_list_id, // when displayed in a list
      affiliation,
      items,
      currency,
      value,
      deviceType
    }
  })
);

export const addToCartOffersEvent = createAnalyticsEvent<{
  eventId: string;
  items: ProductDataTypeForOfferEvent;
  currencyCode: string;
}>(({ items, currencyCode, eventId }) => ({
  event: GAEventName.ADD_TO_CART_OFFERS,
  event_id: eventId,
  ecommerce: {
    currencyCode,
    add: {
      products: items
    }
  }
}));
